import { render } from "./ReturnOrdersComponent.vue?vue&type=template&id=2476fc92"
import script from "./ReturnOrdersComponent.vue?vue&type=script&lang=js"
export * from "./ReturnOrdersComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/account/returnOrders/ReturnOrdersComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2476fc92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2476fc92', __exports__)) {
    api.reload('2476fc92', __exports__)
  }
  
  module.hot.accept("./ReturnOrdersComponent.vue?vue&type=template&id=2476fc92", () => {
    api.rerender('2476fc92', render)
  })

}


export default __exports__